import axios from 'axios'

export default {
  list () {
    return axios.get('/api/search-history')
  },
  add (item) {
    return axios.post('/api/search-history', item)
  },
  remove (dedupKey) {
    return axios.delete('/api/search-history/remove', { params: { dedup_key: dedupKey } })
  },
  clear () {
    return axios.delete('/api/search-history')
  }
}
